import { render, staticRenderFns } from "./StaffUploadAvatar.vue?vue&type=template&id=791e3802&"
import script from "./StaffUploadAvatar.vue?vue&type=script&lang=js&"
export * from "./StaffUploadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./StaffUploadAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports